import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Carousel } from '@xing-com/carousel';
import type { CarouselProps } from '@xing-com/carousel';
import { mediaConfinedOnly } from '@xing-com/layout-tokens';
import { spaceS } from '@xing-com/tokens';

type Props = PropsWithChildren & {
  className?: string;
  itemWidthMobile?: string;
  itemWidthConfined?: string;
  itemSpacing?: string;
  'data-testid'?: string;
};

const StyledCarousel = styled(Carousel)`
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  // space until the edge of the screen
  margin: 0 -20px;
  padding: 0 20px;

  @media ${mediaConfinedOnly} {
    // space until the edge of the screen
    margin: 0 -18px;
    padding: 0 18px;
  }
`;

const getCarouselConfig = (
  itemWidthMobile = '80%',
  itemWidthConfined = '40%',
  itemSpacing = spaceS
): Partial<CarouselProps> => ({
  // mobile
  itemWidth: itemWidthMobile,
  itemSpacing: itemSpacing,

  // tablet
  itemWidthConfined: itemWidthConfined,
  itemSpacingConfined: itemSpacing,
});

export const JobsRecommendationsCarousel: React.FC<Props> = ({
  children,
  className,
  itemWidthMobile,
  itemWidthConfined,
  itemSpacing,
  'data-testid': dataTestId,
}) => {
  return (
    <StyledCarousel
      tabIndex={-1}
      className={className}
      {...getCarouselConfig(itemWidthMobile, itemWidthConfined, itemSpacing)}
      data-testid={dataTestId}
    >
      {children}
    </StyledCarousel>
  );
};
